import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { colors, fonts } from '../brand';
import Disclaimer from '../components/Disclaimer';

const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
  'Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa',
  'Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan',
  'Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire',
  'New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio',
  'Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota',
  'Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia',
  'Wisconsin','Wyoming'
];

export default function Register() {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [state, setState] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const freeToken = new URLSearchParams(location.search).get('free_token') || '';
  const isFreeInvite = !!freeToken;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      await register(email, password, firstName, state, freeToken);
      navigate('/quiz');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        <img src="/logo.svg" alt="Elephants Answering" style={styles.logoIcon} />
        <div>
          <div style={styles.logoText}>Elephants Answering, PBC</div>
          <div style={styles.logoSub}>Divorce Support & Refuge</div>
        </div>
      </div>

      <div style={styles.card}>
        {isFreeInvite && (
          <div style={styles.freeBanner}>
            You've been invited — create your free account below.
          </div>
        )}
        <h2 style={styles.title}>{isFreeInvite ? 'Create Your Free Account' : 'Become a Member'}</h2>
        <p style={styles.tagline}>{isFreeInvite ? 'Your membership is on us. Thank you for sharing your story.' : 'Join the Elephants Answering community.'}</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <input style={styles.input} type="text" placeholder="First name" value={firstName} onChange={e => setFirstName(e.target.value)} required />
          <input style={styles.input} type="email" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={styles.input} type="password" placeholder="Password (8+ characters)" value={password} onChange={e => setPassword(e.target.value)} required />
          <select style={styles.input} value={state} onChange={e => setState(e.target.value)}>
            <option value="">What state are you in? (optional)</option>
            {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Creating account...' : isFreeInvite ? 'Create Free Account' : 'Join Now'}
          </button>
        </form>
        {!isFreeInvite && <p style={styles.fine}>Free for Early Members · No credit card needed</p>}
        <p style={styles.link}>Already have an account? <Link to="/login" style={styles.a}>Sign in</Link></p>
      </div>
      <Disclaimer />
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: colors.cream, padding: '40px 20px' },

  logoArea: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px', cursor: 'pointer' },
  logoIcon: { height: '140px', width: 'auto' },
  logoText: { fontFamily: fonts.heading, color: colors.navy, fontSize: '17px', fontWeight: '600', letterSpacing: '0.5px' },
  logoSub: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '11px', letterSpacing: '0.3px', marginTop: '3px' },

  card: { backgroundColor: colors.white, border: `1px solid ${colors.peach}`, padding: '48px 40px', maxWidth: '420px', width: '100%' },
  freeBanner: { backgroundColor: '#f0f7ee', border: '1px solid #a8d5a2', color: '#2d6a27', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', fontFamily: fonts.body, lineHeight: '1.6' },
  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '24px', marginBottom: '8px', fontWeight: '600', letterSpacing: '0.3px' },
  tagline: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '13px', marginBottom: '32px', fontStyle: 'italic' },

  error: { backgroundColor: '#fde8e8', color: '#c0392b', padding: '12px 16px', marginBottom: '20px', fontSize: '13px', fontFamily: fonts.body, border: '1px solid #f5c6c6' },

  input: { display: 'block', width: '100%', padding: '12px 16px', marginBottom: '16px', border: `1px solid ${colors.peach}`, fontSize: '14px', fontFamily: fonts.body, boxSizing: 'border-box', outline: 'none', color: colors.navy, backgroundColor: colors.white, borderRadius: 0 },

  button: { display: 'block', width: '100%', padding: '14px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '14px', cursor: 'pointer', fontWeight: '600', fontFamily: fonts.body, letterSpacing: '0.5px', borderRadius: 0, marginTop: '4px' },

  fine: { textAlign: 'center', color: colors.textMedium, fontSize: '12px', marginTop: '12px', fontFamily: fonts.body, opacity: 0.7 },
  link: { textAlign: 'center', marginTop: '20px', color: colors.textMedium, fontSize: '13px', fontFamily: fonts.body },
  a: { color: colors.rose, textDecoration: 'none', fontWeight: '600' },
};
